import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { NODE_ENV } from 'src/config-global';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';

const errorLink = onError(({ graphQLErrors }) => {
  const isAccessDenied = graphQLErrors?.[0]?.message === 'ACCESS_DENIED';
  if (isAccessDenied) window.location.href = '/auth/login';
});

export const getApiUrl = () => {
  if (NODE_ENV === 'prod') return 'https://setanta.pro';
  if (NODE_ENV === 'stage') return 'https://redirect.middleware.setantasports.com';
  return 'https://dev.middleware.setantasports.com';
  // return 'http://localhost:4000';
};

const uploadLink = createUploadLink({
  uri: ({ operationName }) => `${getApiUrl()}/graphql?${operationName}`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return { headers: { ...headers, Authorization: token || '' } };
});

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, uploadLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    query: { fetchPolicy: 'no-cache' },
    watchQuery: { fetchPolicy: 'no-cache' },
  },
});

export default client;
